<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span style="font-size: 24px">{{ $t('txml.NewsletterDirectory') }}</span>
    </div>
    <el-container>
      <!-- 这里是侧边栏-->
      <div style="margin-top: 20px">
        <el-aside width="200px" style="
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            text-align: center;
          " class="elAside">
          <el-button type="primary" size="small" @click="showAll">{{ $t('txml.显示全部成员') }}</el-button>
          <div class="zTreeDiv">
            <ul id="PdeptTree" class="ztree"></ul>
          </div>
        </el-aside>
      </div>
      <!-- 这里是内容显示区域 -->

      <el-main>
        <div class="rygl-table">
          <el-table class="margin-20 table" v-loading="loading" :data="communication" height="72vh" style="width: 100%">
            <el-table-column align="center" type="selection" width="55"></el-table-column>
            <el-table-column type="index" align="center" :label="$t('txml.序号')" width="80"></el-table-column>
            <el-table-column align="center" prop="user02" :label="$t('txml.账号')"></el-table-column>
            <el-table-column align="center" prop="user04" :label="$t('txml.姓名')"></el-table-column>
            <el-table-column align="center" prop="prde03" :label="$t('txml.所属组织')"></el-table-column>
            <el-table-column align="center" prop="pror02" :label="$t('txml.岗位')"></el-table-column>
            <el-table-column align="center" prop="user12" :label="$t('txml.邮箱')">
              <template slot-scope="scope">{{
                ($store.state.permissions != null &&
                  !$store.state.permissions.includes("1012")) ||
                  $store.state.isProject
                  ? scope.row.user12
                  : "**************"
              }}
              </template>
            </el-table-column>
            <el-table-column align="center" prop="user11" :label="$t('txml.手机号')">
              <template slot-scope="scope">{{
                ($store.state.permissions != null &&
                  !$store.state.permissions.includes("1011")) ||
                  $store.state.isProject
                  ? scope.row.user11
                  : "**************"
              }}</template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" align="center"
            style="margin-top: 30px" :current-page="pagenum" :page-sizes="[10, 50, 100]" :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-main>
    </el-container>
  </el-card>
</template>

<script>
import { GetProjectdeptZTree, GetDeptUser } from "@/setAxios.js";
export default {
  name: "communication",
  data() {
    return {
      loading: false,
      pagesize: 10,
      pagenum: 1,
      total: 0,
      menuData: [],
      communication: [],
      zNodes: null,
      zTeeObj: null,
      ids: "null",
    };
  },
  methods: {
    showAll() {
      this.ids = "null";
      this.GetDeptUser();
    },
    //初始化ztree
    init() {
      var _this = this;

      var selectNode;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "prde03",
          },
          simpleData: {
            enable: true,
            idKey: "prde01",
            pIdKey: "prde07",
          },
        },
        callback: {
          onCheck: onCheck,
          onClick: onclick,
        },
      };
      this.zTeeObj = $.fn.zTree.init($("#PdeptTree"), setting, this.menuData);

      this.zTeeObj.checkAllNodes(true);

      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.ids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.ids += _split + element.prde01;
        _split = ",";
      });
      _this.GetDeptUser();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.ids = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.ids += _split + element.prde01;
          _split = ",";
        });
        _this.GetDeptUser();
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.pagenum = 1;
        _this.ids = treeNode.prde01;
        _this.GetDeptUser();
      }
    },

    handleNodeClick(data) {
      this.pagenum = 1;
      this.bid = data.ID;
      this.GetDeptUser();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.GetDeptUser();
    },
    handleCurrentChange(val) {
      this.pagenum = val;
      this.GetDeptUser();
    },
    getData() {
      let params = {
        id: localStorage.getItem("xid"),
      };
      GetProjectdeptZTree({ params }).then((res) => {
        this.menuData = res.Data;
        this.init();
      });
    },
    GetDeptUser() {
      this.loading = true;
      let params = {
        xid: localStorage.getItem("xid"),
        bid: this.ids,
        cid: localStorage.getItem("pid"),
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      GetDeptUser({ params }).then((res) => {
        this.loading = false;
        this.total = res.Data.total;
        this.communication = res.Data.list;
      });
    },
  },
  created() { },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.communication {
  // padding: 20px;
}

/deep/ .el-dialog__body {
  padding-bottom: 20px;
}

#PdeptTree {
  height: 500px;
}

.zTreeDiv {
  overflow: auto;
}

.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}
</style>
